import React from "react";
import { BrowserRouter } from "react-router-dom";
import { BreakpointProvider, setDefaultBreakpoints } from "react-socks";

import CalHelmet from "./CalHelmet";
import { GlobalStyles } from "components/ui/GlobalStyles";
import { GlobalStyleVariables } from "components/ui/GlobalStyleVariables";
import { ReduxProvider } from "components/data/ReduxProvider";
import { AppRoutes } from "./routes/AppRoutes";
import { Analytics } from "./Analytics";
import { breakpoints } from "config/media";
import { ConfigLoader } from "./data/ConfigLoader";
import { StatusAndProfileLoader } from "./data/StatusAndProfileLoader";

setDefaultBreakpoints(breakpoints);

export default function App() {
  return (
    <ReduxProvider>
      <CalHelmet />
      <GlobalStyleVariables />
      <GlobalStyles />
      <Analytics />
      <BreakpointProvider>
        <ConfigLoader>
          <StatusAndProfileLoader>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </StatusAndProfileLoader>
        </ConfigLoader>
      </BreakpointProvider>
    </ReduxProvider>
  );
}

App.displayName = "App";
